import { useEffect, useState } from 'react'

const usePackagesRowPerPage = (): [number, (num: number) => void] => {
  const [rowsPackagePerPage, setRowsPackagePerPage] = useState(
    +(localStorage.getItem('pagePackageSize') || 0) || 25,
  )

  useEffect(() => {
    localStorage.setItem('pagePackageSize', String(rowsPackagePerPage))
  }, [rowsPackagePerPage])

  return [rowsPackagePerPage, setRowsPackagePerPage]
}

export default usePackagesRowPerPage
